var _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 670 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M335,336.22C154.47,336.22,8.11,482.58,8.11,663.11S154.47,990,335,990,661.89,843.65,661.89,663.11,515.53,336.22,335,336.22Zm0,526c-109.95,0-199.08-89.13-199.08-199.08S225.05,464,335,464s199.08,89.13,199.08,199.08S445,862.19,335,862.19Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "653.82 315.95 653.82 197.86 335 10 16.18 197.86 16.18 315.95 335 128.11 653.82 315.95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/approved.cd4eb080d659724da9856e229f036771.svg";
export { ForwardRef as ReactComponent };